/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionTypes from './actionTypes';
import { generateQuarter } from '../components/utils';

const initialState = {
  claimAuditSelectScreenData: [],
  pageCountwithDetails: [],
  headerPriceDetails: [],
  getPriceGridDetails: {},
  planTypeDescription: [],
  storeUpdatedDetailsPage: {},
  savePriceDetails: [],
  getAllDrugList: {},
  getManufacturerList: false,
  showQuartes: true,
  deletedUpdatepage: {},
  priceLevelSearchInputdata: {
    rebateProgram: '-1',
    planType: 'COMM',
    drugFamily: 'all',
    quarter: generateQuarter(),
    manufacturerGrid: [],
    mfgId: { mfgId: '', loadMfgGrid: true },
    familySeq: '',
  },
  getRebatePgms: [],
  store_updated_list: {},
  getErrorMsgs: null,
  priceDetailErrors: [],
  UpdatedPage: false,
  mfgId: { mfgId: '', loadMfgGrid: true },
  errControl: {},
  storeAllList: [],
  onchangePayload: {
    rebatePriceDetailVO: [],
    delRebatePriceDetailVO: [],
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_HEADER_PRICE_DETAILS:
      return { ...state, headerPriceDetails: action.payload };
    case actionTypes.GET_PRICE_GRID_DETAILS:
      return { ...state, getPriceGridDetails: action.payload };
    case actionTypes.GET_MANUFACTURER_LIST:
      return { ...state, getManufacturerList: action.payload };
    case actionTypes.CLEAR_SEARCH_REDUX:
      return initialState;
    case actionTypes.GET_DRUG_FAMILIES:
      return { ...state, getAllDrugList: action.payload };
    case actionTypes.SET_SELECTED_DRUG:
      return { ...state, setSelectedDrugFam: action.payload };
    case actionTypes.GET_PAGE_COUNT:
      return { ...state, pageCountwithDetails: action.payload };
    case actionTypes.GET_PLANTYPE_DESCRIPTION:
      return { ...state, planTypeDescription: action.payload };
    case actionTypes.STORE_UPDATED_PAGE:
      return { ...state, storeUpdatedDetailsPage: action.payload };
    case actionTypes.UPDATED_PAGE:
      return { ...state, UpdatedPage: action.payload };
    case actionTypes.SAVE_PRICE_DETAILS:
      return { ...state, savePriceDetails: action.payload };
    case actionTypes.PRICE_DETAIL_ERRORS:
      return { ...state, priceDetailErrors: action.payload };
    case actionTypes.SHOW_ALL_QUARTERS:
      return { ...state, showQuartes: action.payload };
    case actionTypes.DELETED_UPDATED_ROW:
      return { ...state, deletedUpdatepage: action.payload };
    case actionTypes.STORE_REBATE_PRICE_DETAILS:
      return { ...state, storeRebatePriceDetails: action.payload };
    case actionTypes.STORE_BLUR_STATE:
      return { ...state, blurPageState: action.payload };
    case actionTypes.PRICE_DETAILS_ERRORS:
      return { ...state, priceDetailsErrors: action.payload };
    case actionTypes.PRICE_LEVEL_GET_REBATE_PGMS:
      return { ...state, getRebatePgms: action.payload };
    case actionTypes.STORE_UPDATED_LIST:
      return { ...state, store_updated_list: action.payload };
    case actionTypes.REBET_PRICE_LEVEL_SEARCH_INPUT_DATA:
      return { ...state, priceLevelSearchInputdata: action.payload };
    case actionTypes.MFG_ID:
      return { ...state, mfgId: action.payload };
    case actionTypes.ERROR_CONTROL:
      return { ...state, errControl: action.payload };
    case actionTypes.STORE_ALL_LIST:
      return { ...state, storeAllList: action.payload };
    case actionTypes.ONCHANGE_PAYLOAD:
      return { ...state, onchangePayload: action.payload };
    default:
      return state;
  }
};

export default reducer;
